// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 消息列表 POST /common/message/list */
export async function postCommonMessageList(
  body: API.ListParams,
  options?: { [key: string]: any },
) {
  return request<API.ListResult>('/common/message/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 消息已读 POST /common/message/read */
export async function postCommonMessageRead(
  body: API.ReadParams,
  options?: { [key: string]: any },
) {
  return request<API.ReadResult>('/common/message/read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
